import { Tile } from '@timeflies/tilemap-utils';
import * as PIXI from 'pixi.js';
import { textureCache } from '../texture-cache';
export var textureFromIdGetter = function (_a) {
    var mapSheet = _a.mapSheet, mapTexture = _a.mapTexture;
    return function (id, tileset) { return textureCache.getOrElse(id, function () {
        var tilesetTexture = mapTexture[tileset.name];
        var idIndex = id - tileset.firstgid;
        var _a = Tile.getWorldPositionFromTilePosition(Tile.getTilePositionFromTileset(idIndex, tileset), tileset), x = _a.x, y = _a.y;
        var texture = new PIXI.Texture(tilesetTexture.baseTexture, new PIXI.Rectangle(x, y, tileset.tilewidth, tileset.tileheight));
        texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
        return texture;
    }); };
};
